// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"specialists_wrapper__XeHjZ"};